module.exports = __webpack_public_path__ + "img/stage-3-animated.b2babf72.png";